import { companyColors } from "../../global/companyColors";
import { Employee } from "../team/employee-list";

import { drWajmaMangal } from "../team/employees/drWajmaMangal";
import { drJanHeilmann } from "../team/employees/drJanHeilmann";
import { amelieKorn } from "../team/employees/amelieKorn";
import { elizabethHincapieH } from "../team/employees/elizabethHHincapie";
import { torbenSchwarzer } from "../team/employees/torbenSchwarzer";
import { gretaNeubauerKonradies } from "../team/employees/gretaNeuerbauerKonradies";
import { drUlePfeiffer } from "../team/employees/drUlePfeiffer";

export type Service =
  | "startup-advisory"
  | "in-house-and-local-counsel"
  | "dubai-desk"
  | "litigation"
  | "arbitration"
  | "business-and-contract-law"
  | "international-commercial-and-contract-law"
  | "real-estate-and-construction-law"
  | "climate-change-litigation"
  | "esg-compliance"
  | "insolvency-restructuring"
  | "riyadh-desk"
  | "insolvency-restructuring";

export type ServiceDetails = {
  service: Service;
  color: string;
  contactPersons: Employee[];
};

export const servicesList: ServiceDetails[] = [
  {
    service: "litigation",
    color: companyColors.blue[500],
    contactPersons: [drWajmaMangal, amelieKorn],
  },
  {
    service: "arbitration",
    color: companyColors.blue[500],
    contactPersons: [drWajmaMangal, elizabethHincapieH],
  },
  {
    service: "climate-change-litigation",
    color: companyColors.blue[500],
    contactPersons: [drWajmaMangal],
  },
  {
    service: "international-commercial-and-contract-law",
    color: companyColors.blue[200],
    contactPersons: [drWajmaMangal, torbenSchwarzer],
  },
  {
    service: "real-estate-and-construction-law",
    color: companyColors.blue[200],
    contactPersons: [drWajmaMangal, drJanHeilmann, gretaNeubauerKonradies],
  },
  {
    service: "esg-compliance",
    color: companyColors.blue[200],
    contactPersons: [drWajmaMangal],
  },
  {
    service: "startup-advisory",
    color: companyColors.blue[400],
    contactPersons: [drWajmaMangal, drUlePfeiffer],
  },
  {
    service: "in-house-and-local-counsel",
    color: companyColors.blue[400],
    contactPersons: [drWajmaMangal, amelieKorn],
  },
  {
    service: "insolvency-restructuring",
    color: companyColors.blue[400],
    contactPersons: [drWajmaMangal, amelieKorn],
  },
  {
    service: "dubai-desk",
    color: companyColors.blue[400],
    contactPersons: [drWajmaMangal],
  },
  {
    service: "riyadh-desk",
    color: companyColors.blue[200],
    contactPersons: [drWajmaMangal],
  },
];
